import React from "react";
import { useSiteData } from "../../context/SiteDataContext";
import { Wallet, CircleDollarSign, CheckCircle2 } from "lucide-react";

const stepIcons = [Wallet, CircleDollarSign, CheckCircle2];

const HowToBuySection = () => {
  const { content } = useSiteData();
  const howToBuy = content?.howToBuy || [];

  return (
    <section id="howtobuy" className="relative py-20 overflow-hidden">
      <div className="absolute inset-0 bg-[#060d06]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-center mb-4">
          <span className="text-yellow-400">HOW</span>{" "}
          <span className="text-white">TO BUY?</span>
        </h2>
        <p className="text-gray-400 text-center mb-14 max-w-2xl mx-auto">
          Buying MRS tokens is super easy! Follow the three simple steps below.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {howToBuy.map((step, i) => {
            const IconComp = stepIcons[i] || Wallet;
            return (
              <div key={i} className="group relative bg-[#0d1a0d] border border-[#1a3a1a] rounded-2xl p-8 text-center hover:border-yellow-400/30 transition-all duration-500 hover:-translate-y-2">
                <div className="absolute inset-0 bg-gradient-to-b from-yellow-400/5 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="relative">
                  <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-gradient-to-br from-yellow-400/20 to-green-400/10 border border-yellow-400/30 flex items-center justify-center">
                    <IconComp size={28} className="text-yellow-400" />
                  </div>
                  <h3 className="text-white font-bold text-lg mb-3">{step.step}. {step.title}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowToBuySection;
